import { $ } from 'react-jquery-plugin';

// CREATE APP AND utilities OBJECTS if they don't already exist
var APP = window.APP = window.APP || {};
APP.utilities = window.APP.utilities = window.APP.utilities || {};

APP.utilities.resize = (function() {
    var functionsArray = [];
    var resizeTimeout = null;
    var resizeTimer = 500;
    var maxMobile = '600px';
    var minLarge = '960px';

    // CREATES OR UPDATES isMobile AND isLarge VARIABLES
    var updateMatchMedia = function() {
        APP.utilities.isMobile = window.matchMedia('(max-width: '+maxMobile+')').matches;
        APP.utilities.isLarge = window.matchMedia('(min-width: '+minLarge+')').matches;
        // console.log('mobile: '+maxMobile+' & large: '+minLarge);
    };

    // CREATE ARRAY OF FUNCTIONS TO BE CALLED
    var _executeFunctionsArray = function(functionArray) {
        for (var i = 0; i < functionArray.length; i++) {
            var functToExec = window[functionArray[i]];
            if (functToExec && typeof functToExec === 'function') {
                // if it's the name of a global function, execute it!
                console.log('Exec:' + functionArray[i]);
                functToExec();
            } else {
                var objectSplitted = functionArray[i].split('.');
                for (var j = 0; j < objectSplitted.length; j++) {
                    if (j === 0) {
                        functToExec = window[objectSplitted[0]];
                    } else {
                        functToExec = functToExec[objectSplitted[j]];
                    }
                    if (typeof functToExec === 'function') {
                        console.log('Exec:' + functionArray[i]);
                        functToExec();
                        break;
                    }
                }
            }
        }
    };

    // CREATE ONLY ONE LISTENER FOR RESIZE EVENTS
    // Includes buffering
    var _windowResizeGlobalListener = function() {
        $(window).on('resize.global', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                _executeFunctionsArray(APP.utilities.resize.functionsArray);
            }, resizeTimer);
        });
    };

    // ADD FUNCTION TO LIST OF FUNCTIONS CALLED WHEN WINDOW RESIZED
    var addResizeFunction = function(functionName) {
        if ($.inArray(functionName, APP.utilities.resize.functionsArray) === -1) {
            APP.utilities.resize.functionsArray.push(functionName);
            console.log('resize logged: ' + functionName);
        }
    };

    var init = function(sizes) {
        if (sizes && sizes.mobile && sizes.large) {
            maxMobile = sizes.mobile;
            minLarge = sizes.large;
        }
        updateMatchMedia();
        _windowResizeGlobalListener();
        APP.utilities.resize.addFunction('APP.utilities.resize.updateMatchMedia');
    };
    /**
     * interfaces to public functions
     */
    return {
        init: init,
        updateMatchMedia: updateMatchMedia,
        addFunction: addResizeFunction,
        functionsArray: functionsArray
    };

}());

// MODAL TRAPPING
APP.utilities.trap = function(element, attach) {
    var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
    var $element = $(element);
    if (attach) {
        $element.on('keydown.trap', function(event) {
            var $this = $(this);
            if (event.keyCode === 27) { // esc
                $this.find('.close').filter(':first').click();
                event.preventDefault();
            }
            if (event.keyCode === 9) { // tab or shift+tab
                // get list of all children elements in given object
                var children = $this.find('*');
                // get list of focusable items
                var focusableItems = children.filter(focusableElementsString).filter(':visible');
                // get currently focused item
                var focusedItem = $(document.activeElement);
                // get the number of focusable items
                var numberOfFocusableItems = focusableItems.length;
                var focusedItemIndex = focusableItems.index(focusedItem);
                if ((!event.shiftKey && (focusedItemIndex === numberOfFocusableItems - 1)) || numberOfFocusableItems === 1)  {
                    focusableItems.get(0).focus();
                    event.preventDefault();
                }
                if (event.shiftKey && focusedItemIndex === 0) {
                    focusableItems.get(numberOfFocusableItems - 1).focus();
                    event.preventDefault();
                }
            }
        });
    } else {
        $element.off('keydown.trap');
    }
};

APP.utilities.anchor = (function() {
    //BANK DOMAINS THAT DO NOT REQUIRE SPECIAL TREATMENT WHEN LINKING TO
    var exitWhiteList = 'bankofamerica.com,bankofamericastore.com,bettermoneyhabits.com,ml.com,ustrust.com,merrilledge.com,mymerrill.com,maps.google.com,bofaml.com,baml.com,itunes.apple.com,play.google.com'.split(',');

    //WHEN A LINK IS NOT ON THE exitWhiteList, RUN THE CALLBACK FUNCTION ON IT
    var notOnWhiteList = function(callbackToRun) {
        $("a[href^='http']").each( function() {
            var thisLink = $(this);
            var curHref = $(this)[0].hostname;
            var curPass = false;
            $.each(exitWhiteList, function() {
                if (curHref.indexOf(this) > -1) {
                    curPass = true;
                    return false;
                }
            });
            if (!curPass) {
                if ($.isFunction(callbackToRun)) {
                    callbackToRun(thisLink);
                }
            }
        });
    };
    var init = function () {
        console.log('APP.utilities.anchor');
    };
    return {
        init: init,
        notOnWhiteList: notOnWhiteList
    };
}());

APP.core = {};
APP.core.controller = (function () {
    var _route = '';
    var setRoute = function (strVal) {
        _route = strVal;
    };
    var getRoute = function () {
        return _route;
    };
    var locateRoutableElementsInDOM = function (attribute) {
        var matchingElements = [];
        var allElements = document.getElementsByTagName('*');
        for (var i = 0, n = allElements.length; i < n; i++) {
            if (allElements[i].getAttribute(attribute) !== null) {
                // Element exists with attribute. Add to array.
                matchingElements.push(allElements[i]);
            }
        }
        return matchingElements;
    };
    var executeRouteForElement = function (element) {
        var namespace = APP;
        var route = getRoute();
        var action = 'init';
        if (route !== '' && namespace[route] && typeof namespace[route][action] === 'function') {
            namespace[route][action](element);
        }
    };
    var init = function() {
        var routes = locateRoutableElementsInDOM('data-action');
        for (var i = 0; i < routes.length; i++) {
            var element = routes[i];
            var routeName = element.getAttribute('data-action');
            setRoute(routeName);
            console.log('APP.controller.init | APP.' + routeName + '.init() invoked');
            executeRouteForElement(element);
        }
    };
    return {
        init: init
    };
}());

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});
    while (length--) {
        method = methods[length];
        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

APP.global = (function(){
    var initGlobalComponents = function() {
        APP.utilities.resize.init();
        APP.utilities.anchor.init();
    };
    var initPageComponents = function() {
        APP.core.controller.init();
    };
    var init = function() {
        initGlobalComponents();
        initPageComponents();
    };
    return {
        init: init
    };
}());

document.addEventListener("DOMContentLoaded", function() {
  APP.global.init();
});

APP.getapp = (function () {
    //var $telFields = $('.getapp .tel');
    var pageLang = ($('html').attr('lang')) ? $('html').attr('lang').substr(0,2) : 'en';
    // var $newTelFields = $(this).parent().find('.tel');
    // var isMobile = false;
    // var tabshift = false;
    var $getappErrorMessage = $('.getapp__error');
    // var $enterPhoneNumber = $('.getapp__message');
    var $getAppCTA = $('.getAppButton');
    // In page Variables
    var $getAppSelect,
        $inPageGetAppCTA,
        $inPageSubmit,
        $inPageTryAgain;


    var setElements = function (element) {
        $getAppSelect = $(element).find('.js-mobile-device');
        $inPageGetAppCTA = $(element).find('.js-group-one .cta');
        $inPageSubmit = $(element).find('.js-group-two .cta');
        $getappErrorMessage = $(element).find('.getapp__error');
        //$telFields = $(element).find('.getapp .tel');
        $getAppCTA = $(".getAppButton");
        $inPageTryAgain = $(element).find('.js-group-confirmation .cta');
    }    
    



    const hostName = window.location.hostname;
    const dataCenter = ((hostName.indexOf('groupeconnect') > -1) || (hostName.indexOf('.gc.pub') > -1)) ? 'gc' : 'bofa';
    const env = ((hostName.indexOf('-dev') > -1) || (hostName.indexOf('dev-') > -1) || (hostName.indexOf('.dev.') > 1) || (hostName.indexOf('.local.') > -1)) ? 'dev' : 
                    ((hostName.indexOf('-stg') > -1) || (hostName.indexOf('stg-') > -1)) ? 'stg' : 
                    ((hostName.indexOf('qa-') > -1) || (hostName.indexOf('.uat.') > -1)) ? 'qa' : 'prod';

    // Environment data, map to utility service
    const envs = {
        gcdev: 'sms-relay.dev.gc.pub',
        gcqa: 'sms-relay.uat.gc.pub',
        dev: 'utilityorigin-dev-pod1.bankofamerica.com',
        stg: 'utilityorigin-stg-pod1.bankofamerica.com',
        prod: 'utility.bankofamerica.com'
    }

    var getServiceHost = function(env, dataCenter) {
        return "https://" + envs[dataCenter === 'gc' ? "gc" + env : env];
    };
    
    var MobileAppUnit = {
         devices: {
             // OPTION VALUE: [ NAME , CODE ]
             'default1': ['default1', ''],
             'iPhone':['iPhone', 'iphone'],
             'Android':['Android', 'android'],
             'iPhoneES':['iPhone', 'iphone'],
             'AndroidES':['Android', 'android'] 
        },
        //where we'll get the authentication token from
        tokenUri: getServiceHost(env, dataCenter) + '/smsrelay/authentication',
        //where we'll post the 'payload' (user data + token)
        serviceUriApp: getServiceHost(env, dataCenter) + '/smsrelay/sendSMS',
        //will contain the token string
        csrfpTOKEN: ''
    };

    console.log('\ntokenUri:' + MobileAppUnit.tokenUri + '\nserviceUriApp:' + MobileAppUnit.serviceUriApp);

    //determine user's device type
    var userAgent = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        iPhone: function() {
            return navigator.userAgent.match(/iPhone/);
        }
    }; 

    var linkByDevice = function(linkToChange) {
        if(userAgent.iPhone()){
            linkToChange.attr('href', 'https://itunes.apple.com/app/id284847138');
        } else if (userAgent.Android()) {
            linkToChange.attr('href', 'https://play.google.com/store/apps/details?id=com.infonow.bofa');
        } else {
            linkToChange.attr('href', 'https://www.bankofamerica.com/online-banking/android-banking-app/#apple');
        }
    };

    var checkForEmptyFields = function(element) {
        var empty = false;
        var $closestForm = $(element).closest('.getapp__telfields').children('input');

        $closestForm.each(function(){
            if ($(this).val().length < this.maxLength) {
                empty = true;
            }
        });

        if (empty) {
            $getAppCTA.addClass('cta--disabled');
        } else {
            $getAppCTA.removeClass('cta--disabled');
        }

    };

    var autoTabInputs = function(e) {   //working!
        if (e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 16 && e.keyCode !== 9) {
            if (this.value.length === this.maxLength) {
                var $elem = $(this);

                $elem.siblings().eq($elem.index()+1).focus();
                if (($elem).last().prev()) {
                    $(this).parent().siblings('.getapp__error').addClass('getapp__error--hidden');
                    $(this).closest('.getapp__telfields').find('.mobileAppPhone').removeClass('getapp__error--border');
                }
            }  
        } 
        checkForEmptyFields(this);
    };
    
    var disableAlphaValues = function(e) {
        if(e.which === 46){
            return false;
        }else{
            return (e.charCode >= 48 && e.charCode <= 57) || (e.keyCode === 46 || e.keyCode === 8 || e.keyCode === 16 || e.keyCode === 9)
        };
    };

    var optionSelect = function() {
        var $t = $(this);

        if ($t.val() === 'defaultOption') {
            $t.closest('.getapp__group').next().removeClass('getapp__group--visible');
            $t.parent().next().show();
            $t.parent().next().text($t.parent().next().attr('data-default-text'));
            $t.parent().siblings('.getapp__error').addClass('getapp__error--hidden');
            $t.parent().closest('.getapp__custom .getapp__dropdown').removeClass('getapp__error--border');
            $t.parents().closest('.getapp__controls').find('.getapp__telfields .mobileAppPhone').removeClass('getapp__error--border');
            $t.parent().siblings('.getapp__error').focus();
        } else {
            $t.parent().next().hide();
            $t.closest('.getapp__group').next().addClass('getapp__group--visible'); 
            $t.parent().siblings('.getapp__error').addClass('getapp__error--hidden');
            $t.parent().closest('.getapp__group').next().find('.js-enter-tel').addClass('getapp__error--hidden');
            $t.closest('.getapp__custom .getapp__dropdown').removeClass('getapp__error--border');
            $t.parents().closest('.getapp__controls').find('.getapp__telfields .mobileAppPhone').removeClass('getapp__error--border');
            $t.parent().closest('.getapp__group').next().find('input:first').focus();
        }
    };

    var checkForSelectError = function(e) {
        if ($(this).hasClass('cta--disabled')) {
            $(this).siblings('.getapp__error').removeClass('getapp__error--hidden').focus();
            $(this).closest('.getapp__telfields').find('.mobileAppPhone').addClass('getapp__error--border');
            $(this).parent().find('.getapp__custom .getapp__dropdown').removeClass('getapp__error--border');
            $(this).parent().find('.getapp__custom .getapp__dropdown').addClass('getapp__error--border');
        }

        e.preventDefault();
    };

    //for ADA, put DOM focus on first phone # field if there is a click/keypress on the error msg (probably never happens)
    var refocusAfterError = function(e) {
        var $t = $(this);

        if ($t.hasClass('js-enter-tel')) {
            $t.nextAll('.getapp__telfields').find('input:first').focus();
        } else {
            $t.nextAll('.getapp__custom').find('.js-mobile-device').focus();
        }

        e.preventDefault();
    };

    //this could be 'success OR failure' when called. 'handleFormSubmit' will figure out which. 'e/this' is the Submit button
    var showConfirmation = function(e) {
        if ($(this).hasClass('cta--disabled')) {
            $(this).parent().siblings('.getapp__error').removeClass('getapp__error--hidden').focus();
            $(this).closest('.getapp__telfields').find('.mobileAppPhone').addClass('getapp__error--border');
        } else {
            handleFormSubmit(this);
            var valOne = $(this).closest('.getapp__telfields').find('.js-tel-areacode').val(),
                valTwo = $(this).closest('.getapp__telfields').find('.js-tel-three').val(),
                valThree = $(this).closest('.getapp__telfields').find('.js-tel-four').val();

            $(this).closest('.getapp__controls').find('.getapp__group').hide();
            $(this).closest('.getapp__group').next().show().focus();
            $(this).closest('.getapp__group').next().find('.js-phonenumber').text("(" +valOne + ") " + valTwo + " " + valThree);         
        }

        e.preventDefault();       
    };

      //if we ended in failure, provide a way back to the form to try again
      var tryAgain = function(e) {
        $(this).parents('.js-group-confirmation').siblings('.js-group-one').show().siblings('.js-group-two').show().find('input.tel:first').focus();
        $(this).parents('.js-group-confirmation').hide().find('.mobileApp_spinner').prop('hidden', false).siblings('.getapp__success, .getapp__failure').prop('hidden', true);
        e.preventDefault();       
    };

    var showFailState = function() {
        $('.js-group-two').closest('.getapp').find('.mobileApp_spinner').prop('hidden', true).siblings('.getapp__failure').prop('hidden', false);
    };

    //handles failure message visibility if service call times-out
    var smsFail;
    var smsFailFunc = function() {
        smsFail = setTimeout(function(){ 
            showFailState();
        }, 20000);
    };
    var smsFailStopFunc = function() {
      clearTimeout(smsFail);
    };


    var handleFormSubmit = function(element) {
        var closestGroup = $(element).closest('.getapp__controls');
        var deviceType = MobileAppUnit.devices[closestGroup.find('.js-mobile-device option:selected').val()][1];
        var areaCode = closestGroup.find('.js-tel-areacode');
        var prefix = closestGroup.find('.js-tel-three');
        var lineNumber = closestGroup.find('.js-tel-four');

        //start the clock on 20-sec timeout limit, this will be cancelled upon service call completion 
        smsFailFunc();

        //get authentication token from middleware Java service
        $.get(MobileAppUnit.tokenUri, function(data) {
            var jsonStr = JSON.stringify(data);
            var jsonObj = JSON.parse(jsonStr);
            var jsonData = jsonObj["token"];
            MobileAppUnit.csrfpTOKEN = jsonData;
            var http = new XMLHttpRequest();
            var url = MobileAppUnit.serviceUriApp;
            var params = '{"smsRequest":{"type":"mobileapp","phone":"1' + areaCode.val() + prefix.val() + lineNumber.val() + '","language":"' + pageLang + '","device":"' + deviceType + '"}}';

            //SEND VALUES TO Java service BY POST
            http.open("POST", url, true);
            http.setRequestHeader("Content-type", "application/json");
            http.setRequestHeader("Authorization", "Bearer " + MobileAppUnit.csrfpTOKEN);
            http.onreadystatechange = function() {
                //wait until we're done talking with the service
                if(http.readyState === 4) {
                    //cancel the 20-sec timeout failsafe
                    smsFailStopFunc();
                    //success, hide the spinner & show the success message
                    if (http.status === 200) {
                        console.log('Send complete, readyState:' + http.readyState + ', status:' + http.status);
                        $('.js-group-two').closest('.getapp').find('.mobileApp_spinner').prop('hidden', true).siblings('.getapp__success').prop('hidden', false);
                        $('.getapp__failure').remove();
                    //failure, hide the spinner & show the try-again message
                    } else {
                        console.log('Send failed, readyState:' + http.readyState + ', status:' + http.status);
                        $('.js-group-two').closest('.getapp').find('.mobileApp_spinner').prop('hidden', true).siblings('.getapp__failure').remove();
                        showFailState();
                    }
                }
            };
            http.send(params);
        });
        //END SEND VALUES TO Java service BY POST


        setTimeout(function(){
            $('.js-group-two').closest('.getapp-widget').find('.mobileApp_spinner').removeClass('active');
        }, 1000);
    }; 

    var bindEventsToUI = function () {
        // Focus on next field upon reaching max length of current focused input
        // Global AutoTab Event
        $('.getapp .tel').on('keyup keydown', autoTabInputs);
        $('.getapp .tel').on('keypress', disableAlphaValues);
        $getAppSelect.on('change', optionSelect);
        $inPageGetAppCTA.on('click', checkForSelectError);
        $inPageSubmit.on('click', showConfirmation);
        $inPageTryAgain.on('click', tryAgain);
        $getappErrorMessage.on('keypress click', refocusAfterError);
        linkByDevice($('.cta--dynamic'));

        $inPageGetAppCTA.on('click', function(e){   
            e.preventDefault();
        });

        $('select').each(function () {
            $(this).val($(this).find('option:first').val());
        });
    };

    var init = function () {
        // uncomment the following line to access the DOM element invoking this component
        var element = arguments[0];
        setElements(element);
        bindEventsToUI();
    };

    /**
     * interfaces to public functions
     */
    return {
        init: init,
        getServiceHost: getServiceHost
    };

}());

window.addEventListener("load", function() {
    APP.getapp.init();
});

export default APP;